import { toMoney } from '@/utils/tools'
export default class AbnormalStatistics {
  static getHeader () {
    return [
      {
        sortable: false,
        text: this.$t('channel'),
        value: 'channel',
        width: '150px'
      },
      // {
      //   sortable: false,
      //   text: this.$t('clientName'),
      //   value: 'clientName',
      //   width: '20%'
      // },
      // {
      //   sortable: false,
      //   text: this.$t('department'),
      //   value: 'department',
      //   width: '10%'
      // },
      // {
      //   sortable: false,
      //   text: this.$t('manager'),
      //   value: 'manager',
      //   width: '10%'
      // },
      {
        sortable: true,
        text: this.$t('abnormalStatistics.invoiceCount'),
        value: 'invCount',
        width: '150px'
      },
      // {
      //   sortable: true,
      //   text: this.$t('abnormalStatistics.mpsCount'),
      //   value: 'mpsCount',
      //   width: '150px'
      // },
      {
        sortable: true,
        text: this.$t('abnormalStatistics.diffAmountRate'),
        value: 'diffAmountRate',
        format: item => `${item.prepaidAmount && item.diffAmount ? toMoney((item.diffAmount / item.prepaidAmount) * 100) : 0}%`,
        width: '150px'
      },
      {
        sortable: true,
        text: this.$t('abnormalStatistics.diffAmount'),
        value: 'diffAmount',
        // format: item => `${item.prepaidAmount && item.diffAmount ? toMoney((item.diffAmount / item.prepaidAmount) * 100) : 0}%`,
        isMoney: true,
        format: (item, row) => toMoney(item[row.value || 0]),
        width: '150px'
      },
      {
        sortable: true,
        text: this.$t('abnormalStatistics.prepaidAmount'),
        value: 'prepaidAmount',
        isMoney: true,
        format: (item, row) => toMoney(item[row.value || 0]),
        width: '150px'
      },
      {
        sortable: true,
        text: this.$t('abnormalStatistics.billingWeight'),
        value: 'billingWeight',
        format: (item, row) => toMoney(item[row.value || 0]),
        width: '150px'
      },
      {
        sortable: true,
        text: this.$t('abnormalStatistics.originBillingWeight'),
        value: 'originBillingWeight',
        format: (item, row) => toMoney(item[row.value || 0]),
        width: '150px'
      },
      {
        sortable: true,
        text: this.$t('abnormalStatistics.diffBillingWeight'),
        value: 'diffBillingWeight',
        format: (item, row) => toMoney(item[row.value || 0]),
        width: '150px'
      },
      ...AbnormalStatistics.zoneItems.map(item => ({
        sortable: true,
        text: item,
        value: item,
        width: '150px'
      }))
    ]
  }

  static zoneItems = new Array(7)
    .fill('zone')
    .map((zone, i) => `${zone}_0${i + 1}`)

  diffAmount = 0
  prepaidAmount = 0

  constructor (obj) {
    Object.keys(obj).forEach(key => {
      this[key] = obj[key]
    })
  }

  get totalZone () {
    return AbnormalStatistics.zoneItems.reduce((sum, zone) => {
      return (sum += this[zone] || 0)
    }, 0)
  }
}



// WEBPACK FOOTER //
// ./src/orm/models/AbnormalStatistics.js